/**
 * Tracker-specific rotation preview status without implying write permission.
 * For Media Devoted | Created By Ciro Autiero
 */
import { matchTracker, type RotationPreviewResult } from '@trafficpulse/shared';

export function rotationWriteNotice(result: RotationPreviewResult): string {
  const legacy = () => (result.trackerWritesEnabled
    ? `Tracker writes ON — changes push to ${result.provider}.`
    : 'Tracker writes OFF — local only (the live flow is not touched).') + (result.applied ? ' Applied.' : '');
  return matchTracker(result.provider, {
    voluum: legacy, binom: legacy,
    'tres-commas': () => {
      if (result.applied) return 'Applied to Tres Commas.';
      if (result.error) return `Nothing pushed: ${result.error}`;
      if (result.appliedAt) return 'Local queue updated — nothing pushed to Tres Commas.';
      if (result.trackerWritesEnabled === false) return 'Preview only — pushes are paused; applying may update the local queue after permission checks.';
      return 'Preview only — Tres Commas checks write permissions when you apply.';
    },
  });
}
